import { Typography, Row, Col } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { AiFillEdit, AiFillDelete, AiFillCloseCircle } from "react-icons/ai";
import MeetingAttendersTable from "./MeetingAttendersTable";

import { Modal } from "antd";
const { confirm } = Modal;

const MeetingDetails = () => {
  const [searchparams] = useSearchParams();
  const _id = searchparams.get("_id");
  const meetingName = searchparams.get("meetingName");
  const meetingAuthor = searchparams.get("meetingAuthor");
  const meetingAuthorFullName = searchparams.get("meetingAuthorFullName");
  const meetingRoomName = searchparams.get("meetingRoomName");
  const meetingStartDate = searchparams.get("meetingStartDate");
  const meetingStartTime2 = searchparams.get("meetingStartTime2");
  const meetingEndDate = searchparams.get("meetingEndDate");
  const meetingEndTime2 = searchparams.get("meetingEndTime2");
  const meetingAttenders = searchparams.get("meetingAttenders").split(",");
  meetingAttenders.push(meetingAuthor);
  const meetingAbout = searchparams.get("meetingAbout");

  const [attenders, setAttenders] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getAttenders();
  }, []);

  const getAttenders = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-attenders/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
        body: JSON.stringify({ _id, meetingAttenders }),
      }
    );
    result = await result.json();
    setAttenders(result);
  };

  const showDeleteConfirm = (meetingName, _id) => {
    confirm({
      centered: "centered",
      title: meetingName,
      icon: <ExclamationCircleFilled />,
      content: "Görüşü silmək istədiyinizdən əminsiniz?",
      okText: "Sil",
      okType: "danger",
      cancelText: "İmtina Et",
      onOk() {
        deleteMeeting(_id);
      },
      onCancel() {},
    });
  };

  const deleteMeeting = async (_id) => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/meeting/${_id}`,
      {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
        body: JSON.stringify({
          meetingName,
          meetingAuthorFullName,
          meetingAttenders,
        }),
      }
    );
    result = await result.json();

    if (result) {
      navigate("/meetings");
    }
  };

  return (
    <>
      <Row>
        <Col span={9}>
          <Typography.Title level={5} className="titles-start">
            Görüşün rəhbəri
          </Typography.Title>
          <Typography.Text className="titles-start-meeting">
            {meetingAuthorFullName}
          </Typography.Text>
        </Col>
        <Col span={4}>
          <div style={{ textAlign: "center" }}>
            <Typography.Title level={5} className="titles-start">
              Görüş otağı
            </Typography.Title>
            <div style={{ display: "grid" }}>
              <Typography.Text className="titles-start">
                {meetingRoomName}
              </Typography.Text>
            </div>
          </div>
        </Col>
        <Col span={4}>
          <div style={{ textAlign: "center" }}>
            <Typography.Title level={5} className="titles-start">
              Başlama tarixi
            </Typography.Title>
            <div style={{ display: "grid" }}>
              <Typography.Text className="titles-start">
                {meetingStartDate}
              </Typography.Text>
              <Typography.Text className="titles-start">
                {meetingStartTime2}
              </Typography.Text>
            </div>
          </div>
        </Col>
        <Col span={4}>
          <div style={{ textAlign: "center" }}>
            <Typography.Title level={5} className="titles-start">
              Bitmə tarixi
            </Typography.Title>
            <div style={{ display: "grid" }}>
              <Typography.Text className="titles-start">
                {meetingEndDate}
              </Typography.Text>
              <Typography.Text className="titles-start">
                {meetingEndTime2}
              </Typography.Text>
            </div>
          </div>
        </Col>
        <Col span={1}>
          <Typography.Title
            style={{ cursor: "pointer" }}
            level={2}
            className="titles-start"
          >
            <Link
              state={{ id: _id }}
              style={{ color: "#870447" }}
              to="/meetingedit"
            >
              {<AiFillEdit />}
            </Link>
          </Typography.Title>
        </Col>
        <Col span={1}>
          <Typography.Title
            style={{ cursor: "pointer" }}
            level={2}
            className="titles-start"
            onClick={() => showDeleteConfirm(meetingName, _id)}
          >
            <AiFillDelete />
          </Typography.Title>
        </Col>
        <Col span={1}>
          <Typography.Title
            style={{ cursor: "pointer" }}
            level={2}
            className="titles-start"
            onClick={() => {
              navigate(-1);
            }}
          >
            <AiFillCloseCircle />
          </Typography.Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Title>
            <hr></hr>
          </Typography.Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Title level={5} className="titles-start">
            Görüşün predmeti
          </Typography.Title>
          <Typography.Text>{meetingAbout}</Typography.Text>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Title>
            <hr></hr>
          </Typography.Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Title level={5} className="titles-start">
            İştirakçılar
          </Typography.Title>
          <MeetingAttendersTable attenders={attenders} />
        </Col>
      </Row>
    </>
  );
};

export default MeetingDetails;
